import {getTranslation} from './translations';

/* eslint-disable no-undef */
const computed = typeof Vue !== 'undefined' ? Vue.computed : null;

const template = `
	<div class="ubf-dynamicList__filterSelected">
		<template v-if="linkedId.value !== ''">
			<button class="ubf-dynamicList__selectedLabel" @click="onRemoveLinkedId" :aria-label="trans('showAll')">
				<span>{{ trans('linked') }}:</span>
				<span class="ubf-dynamicList__remove"><span data-type="svg"><canvas width="12" height="12"></canvas><svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><use xlink:href="#cancel"></use></svg></span></span>
			</button>
		</template>
		<template v-if="search.value !== ''">
			<button class="ubf-dynamicList__selectedLabel" @click="onRemoveSearch" :aria-label="trans('resetSearch')">
				<span>{{ trans('resetSearch') }}: {{ search.value }}</span>
				<span class="ubf-dynamicList__remove"><span data-type="svg"><canvas width="12" height="12"></canvas><svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><use xlink:href="#cancel"></use></svg></span></span>
			</button>
		</template>
		<template v-for="(filter, key) in filters"  :key="key">
			<template v-if="filter.length > 0 || Object.keys(filter).length > 0">
				<template v-if="getDefinition(key).type === 'multi-select'">
					<button class="ubf-dynamicList__selectedLabel" v-for="selected in filter" @click="onRemoveFilter(key, selected)" :aria-label="'Filter ' + selected + ' entfernen'">
						<span v-if="!getDefinition(key).hideLabel">{{ getDefinition(key).title }}:</span>
						<span>{{ getOptionLabel(key, selected) }}</span>
						<span class="ubf-dynamicList__remove"><span data-type="svg"><canvas width="12" height="12"></canvas><svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><use xlink:href="#cancel"></use></svg></span></span>
					</button>
				</template>
				<template v-else-if="getDefinition(key).type === 'single-select'">
					<button class="ubf-dynamicList__selectedLabel" @click="onRemoveFilter(key, filter)" :aria-label="'Filter ' + filter + ' entfernen'">
						<span v-if="!getDefinition(key).hideLabel">{{ getDefinition(key).title }}:</span>
						<span>{{ getOptionLabel(key, filter) }}</span>
						<span class="ubf-dynamicList__remove"><span data-type="svg"><canvas width="12" height="12"></canvas><svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><use xlink:href="#cancel"></use></svg></span></span>
					</button>
				</template>
				<template v-else-if="getDefinition(key).type === 'date' || getDefinition(key).type === 'interval'">
					<button v-if="filter.from" class="ubf-dynamicList__selectedLabel" @click="onRemoveFromFilter(key, filter)" :aria-label="'Filter entfernen'">
						<span>{{getDefinition(key).title}} nach {{ filter.from !== 'now' ? new Date(filter.from).toLocaleDateString() : trans('today')}}</span>
						<span class="ubf-dynamicList__remove"><span data-type="svg"><canvas width="12" height="12"></canvas><svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><use xlink:href="#cancel"></use></svg></span></span>
					</button>
					<button v-if="filter.to" class="ubf-dynamicList__selectedLabel" @click="onRemoveToFilter(key, filter)" :aria-label="'Filter entfernen'">
						<span>{{getDefinition(key).title}} bevor {{ filter.to !== 'now' ? new Date(filter.to).toLocaleDateString() : trans('today')}}</span>
						<span class="ubf-dynamicList__remove"><span data-type="svg"><canvas width="12" height="12"></canvas><svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><use xlink:href="#cancel"></use></svg></span></span>
					</button>
				</template>
				<template v-else-if="getDefinition(key).type === 'text' || getDefinition(key).type === 'textarea'">
					<button class="ubf-dynamicList__selectedLabel" @click="onRemoveFilter(key, filter)" :aria-label="'Filter ' + filter + ' entfernen'">
						<span v-if="!getDefinition(key).hideLabel">{{ getDefinition(key).title }}:</span>
						<span>{{ filter }}</span>
						<span class="ubf-dynamicList__remove"><span data-type="svg"><canvas width="12" height="12"></canvas><svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><use xlink:href="#cancel"></use></svg></span></span>
					</button>
				</template>
				<template v-else>
					<button class="ubf-dynamicList__selectedLabel" @click="onRemoveFilter(key, filter)" :aria-label="'Filter ' + filter + ' entfernen'">
						<span v-if="!getDefinition(key).hideLabel">{{ getDefinition(key).title }}:</span>
						<span>{{ filter }}</span>
						<span class="ubf-dynamicList__remove"><span data-type="svg"><canvas width="12" height="12"></canvas><svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><use xlink:href="#cancel"></use></svg></span></span>
					</button>
				</template>
			</template>
		</template>
		<div v-if="hasFilters" class="ubf-dynamicList__selectedLink">
			<div class="ubf-dynamicList__selectedLink__tooltip">{{ trans('copyClipboard') }}</div>
			<a href="#" :title="trans('directLink')" @click="onShareLink()">
				<span data-type="svg"><canvas width="20" height="20"></canvas><svg viewBox="0 0 20 20" focusable="false"><use xlink:href="#link"></use></svg></span>
			</a>
		</div>
	</div>
`;

export default {
	template: template,
	emits: ['filter-remove', 'filter-change', 'search-remove', 'linked-id-remove'],
	components: {},
	props: {
		definitions: Object,
		filters: Object,
		search: Object,
		linkedId: Object
	},
	setup: function (props) {
		const shareLink = computed(() => {
			//const search = props.search.value;
			//const linkedId = props.linkedId.value;
			const filters = props.filters;

			if (Object.keys(filters).length === 0) return '';
			const filterString = Object.keys(filters).map(key => {
				const filter = filters[key];
				if (filter.hasOwnProperty('from')) {
					return key + ':' + filter.from + '|' + (filter.to ? filter.to : '');
				} else if (Array.isArray(filter)) {
					return key + ':' + filter.join('|');
				} else {
					return key + ':' + filter;
				}
			});

			return '?filter=' + encodeURIComponent(filterString.join(';'));
		});
		const hasFilters = computed(() => Object.entries(props.filters).some(([, value]) => (
					(value !== '' && value.length > 0) ||
					(value.hasOwnProperty('from') && value.from !== '') ||
					(value.hasOwnProperty('to') && value.to !== '')
				)
			));
		return {
			trans: getTranslation,
			filters: props.filters,
			hasFilters: hasFilters,
			definitions: props.definitions,
			search: props.search,
			linkedId: props.linkedId,
			shareLink: shareLink,
		};
	},
	methods: {
		getDefinition: function (key) {
			return this.definitions.find(def => def.id === key);
		},
		getOptionLabel: function (key, id) {
			const definition = this.definitions.find(def => def.id === key);
			if (definition.type === 'multi-select') {
				return definition.preset.find(opt => opt.id === id).label;
			} else if (definition.type === 'single-select') {
				return definition.preset.find(opt => opt.id === id).label;
			} else {
				return id;
			}

		},
		onRemoveFilter: function (key, filter) {
			this.$emit('filter-remove', {key: key, filter: filter});
		},
		onRemoveToFilter: function (key, filter) {
			filter.to = '';
			this.$emit('filter-change', {key: key, filter: filter});
		},
		onRemoveFromFilter: function (key, filter) {
			filter.from = '';
			this.$emit('filter-change', {key: key, filter: filter});
		},
		onRemoveSearch: function () {
			this.$emit('search-remove');
		},
		onRemoveLinkedId: function () {
			this.$emit('linked-id-remove');
		},
		onShareLink: function () {
			// copy url to clipboard
			const pageUrl = window.location.href.split(/[?#]/)[0];
			navigator.clipboard.writeText(pageUrl + this.shareLink);
			return false;
		}
	},
};

